export function stationDetailsReducer(state, action) {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };

    case "TOGGLE_GROUP":
      return {
        ...state,
        groupNames: state.groupNames.includes(action.group)
          ? state.groupNames.filter((g) => g !== action.group)
          : [...state.groupNames, action.group],
      };

    case "SET_LOCATION":
      return {
        ...state,
        location: {
          ...state.location,
          [action.field]: action.value,
        },
      };

    case "SET_SIS":
      return {
        ...state,
        sis: {
          ...state.sis,
          [action.field]: action.value,
        },
      };

    case "SET_INT":
      return {
        ...state,
        int: {
          ...(state.int || {}),
          [action.direction]: {
            ...((state.int && state.int[action.direction]) || {}),
            [action.field]: action.value,
          },
        },
      };

    case "DISABLE_SIS_INT":
      return {
        ...state,
        sis: null,
        int: null,
      };

    case "RESET":
      return createInitialState(action.availableGroups);

    case "SET_ALL":
      return action.payload;

    default:
      return state;
  }
}
